import { STATUSES } from '@/constants/common/message.constants'

import { type TruckImportJobExEntity } from '../../aspida/@types'

/**
 * 車両取込ステータス
 */
export type TruckImportJobStatusType = TruckImportJobExEntity['status']

export const TRUCK_IMPORT_JOB_STATUS_TYPE = {
  /** 取込待ち */
  PENDING: 'PENDING',
  /** 取込中 */
  IMPORTING: 'IMPORTING',
  /** 完了 */
  COMPLETED: 'COMPLETED',
  /** エラー */
  ERROR: 'ERROR'
} as const satisfies Record<TruckImportJobStatusType, TruckImportJobStatusType>

export const TRUCK_IMPORT_JOB_STATUS_TYPE_LABEL = {
  [TRUCK_IMPORT_JOB_STATUS_TYPE.PENDING]: STATUSES.PENDING,
  [TRUCK_IMPORT_JOB_STATUS_TYPE.IMPORTING]: STATUSES.PROCESSING,
  [TRUCK_IMPORT_JOB_STATUS_TYPE.COMPLETED]: STATUSES.COMPLETED,
  [TRUCK_IMPORT_JOB_STATUS_TYPE.ERROR]: STATUSES.FAILED
} as const satisfies Record<TruckImportJobStatusType, string>
